import { useMediaQuery } from "@mui/material";
import Carousel from "react-material-ui-carousel";

const Carousels = (content: Array<string>) => {
  let carouselArray: Array<string> = [];
  for (let i in content) {
    carouselArray.push(content[i]);
  }
  return (
    <Carousel
      sx={{
        width: "100vw",
        indicators: { display: "none" },
      }}
      autoPlay
      navButtonsAlwaysVisible
      animation="slide"
      indicatorContainerProps={{
        style: {
          zIndex: 1,
          marginTop: "-10px",
          position: "relative",
        },
      }}
      indicators={false}
    >
      {carouselArray?.map((item, i) => (
        <Item key={i} item={item} />
      ))}
    </Carousel>
  );
};

interface ItemProps {
  key: number;
  item: string;
}

function Item({ item }: ItemProps) {
  const matches = useMediaQuery("(max-width:900px)");
  let h = "70vh";
  if (!matches) {
    h = "80vh";
  } else {
    h = "40vh";
  }
  return (
    <img
      src={`${item}`}
      alt="images"
      style={{
        display: "block",
        height: `${h}`,
        width: "100vw",
        margin: 3,
        // objectFit: "unset",
      }}
    />
  );
}

export default Carousels;
